import { render, staticRenderFns } from "./data-presentation.vue?vue&type=template&id=a0101cb6"
import script from "./data-presentation.vue?vue&type=script&lang=js"
export * from "./data-presentation.vue?vue&type=script&lang=js"
import style0 from "./data-presentation.vue?vue&type=style&index=0&id=a0101cb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports